import * as config from './config.js'

export default {
  config
}
